import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b188c1a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "horizontal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "応募の一覧", -1))
const _hoisted_3 = { style: {"padding":"1rem"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 新しい応募を作成 ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "apply" }
const _hoisted_7 = { class: "horizontal" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_badge = _resolveComponent("n-badge")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_collapse_transition = _resolveComponent("n-collapse-transition")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_collapse_transition, {
        show: !_ctx.totalLoading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_layout, { style: {"padding":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_Menu),
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_n_button, {
                    type: "primary",
                    onClick: _ctx.addNew
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_add_icon)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_n_space, {
                    key: 0,
                    vertical: "",
                    style: {"background-color":"white","padding":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_skeleton, {
                        height: "1rem",
                        width: "33%"
                      }),
                      _createVNode(_component_n_skeleton, {
                        height: "1rem",
                        width: "66%",
                        sharp: false
                      }),
                      _createVNode(_component_n_skeleton, {
                        height: "1rem",
                        width: "66%",
                        sharp: false
                      })
                    ]),
                    _: 1
                  }))
                : (_ctx.applys.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applys, (a) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: a.id
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("p", _hoisted_8, _toDisplayString(a.labelTag), 1),
                              _createVNode(_component_n_badge, {
                                value: _ctx.label(a.status),
                                color: _ctx.labelColor(a.status),
                                class: "badge"
                              }, null, 8, ["value", "color"])
                            ]),
                            _createElementVNode("p", null, "作成日: " + _toDisplayString(_ctx.getDate(a.createdAtUnix)), 1),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.lookCheck(a.id))
                            }, "見え方の確認", 8, _hoisted_9),
                            _hoisted_10,
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.goApplyEdit(a.id, a.status))
                            }, "編集", 8, _hoisted_11),
                            _hoisted_12,
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.copyNew(a.id))
                            }, "複製", 8, _hoisted_13),
                            (a.status === 'public')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_14,
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.finish(a.id))
                                  }, "求人の削除", 8, _hoisted_15)
                                ], 64))
                              : _createCommentVNode("", true),
                            (a.status === 'finish' && _ctx.usePremium)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_16,
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.archive(a.id))
                                  }, "やり取り停止", 8, _hoisted_17)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_n_divider, { class: "noMargin" })
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_n_empty, { description: "応募はまだ作成されていません" })
                    ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_n_collapse_transition, { show: _ctx.totalLoading }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}